
import Foot from "@/layouts/foot";
export default {
  name: "index",
  components: {Foot},
  head() {
    return {
      title: 'Πληροφορίες επαφής',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: "Soru ve önerileriniz için bizimle iletişime geçebilirsiniz."
        },
        { hid: 'keywords', name: 'keywords', content: "servislet, michelin, kormoran, petlas, dunlop, falken, iletişim, servislet destek, servislet adresi, servislet telefon, servislet müşteri hizmetleri" }
      ],
    }
  }
}
